import { arrayBufferToBase64 } from '../utils/utils';
import { VaultOperation } from './vault-operation';
export class ValidationContext {
    constructor(entries, validateFromEntry) {
        this.entries = entries.slice(0, validateFromEntry);
        this.expectedId = validateFromEntry;
        this.idByPublicKey = new Map();
        this.entries.forEach(entry => {
            if (entry.operation === VaultOperation.AddKey) {
                const publicKeyBase64Encoded = arrayBufferToBase64(entry.requestorPublicKey.buffer);
                this.idByPublicKey.set(publicKeyBase64Encoded, entry.id);
            }
        });
        this.revokedIds = new Set(this.entries
            .filter(entry => entry.operation === VaultOperation.RemoveKey)
            .map(entry => this.idByPublicKey.get(arrayBufferToBase64(entry.requestorPublicKey.buffer))));
    }
}
